/*
 * @Description: 自动优化规则弹窗
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-09-25 15:59:19
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-15 10:46:07
 */
<template>
    <Modal v-model="showModal"
           @on-visible-change="onVisibleChange"
           ok-text="保存"
           @on-ok="onSave"
           width="520"
           class="optimization-modal"
    >
        <p slot="header" class="title">自动优化规则</p>
        <div class="optimization-modal">
            <!-- 名称 -->
            <div class="row">
                <div class="row-left">名称</div>
                <div class="row-right">
                    <Input v-model="value.name"
                           style="width:3.33rem" 
                           placeholder="选填，默认按字段名拼接" />
                </div>
            </div>
            <!-- 维度 -->
            <div class="row">
                <div class="row-left">维度</div>
                <div class="row-right">
                    <Select v-model="value.type" placeholder="请选择维度" style="width:3.33rem">
                        <Option v-for="item in dimensionList" :value="item.value" :label="item.label" :key="item.value">{{item.label}}</Option>
                    </Select>
                </div>
            </div>
            <!-- 条件 -->
            <div class="row">
                <div class="row-left">条件</div>
                <div class="row-right">
                    <Select v-model="value.conditionArr" placeholder="请选择条件" filterable multiple style="width:3.33rem">
                        <Option v-for="item in quotaList" :value="item.value" :key="item.value">{{item.label}}</Option>
                    </Select>
                    <Icon v-if="reg.conditionArr" type="android-cancel" class="icon-error"></Icon>
                </div>
            </div>
            <!-- CVR条件 -->
            <template v-for="item in quotaList">
                <div :key="item.value" class="row" v-if="value.conditionArr.includes(item.value)">
                    <div class="row-left"></div>
                    <div class="row-right">
                        <span style="display:inline-block;width:0.55rem">{{item.label}}</span>
                        <Select v-model="value.conditionObject[item.value].operator" style="width:0.6rem;font-weight:bold">
                            <Option v-for="math in mathList" :value="math.value" :key="math.value" :label="math.label">{{math.label}}</Option>
                        </Select>
                        <Input 
                            v-model="value.conditionObject[item.value].indicatorValue"
                            :element-id="item.value+''"
                            @on-keyup="onIndicatorValueChange"
                            @on-change="onIndicatorValueChange"
                            style="width:1.35rem"
                        />
                        <span style="display:inline-block;width:0.415rem">{{unitList[item.value]}}</span>
                        <Button type="info" size="small" @click="value.conditionArr.splice(value.conditionArr.indexOf(item.value),1)">X</Button>
                        <Icon v-if="reg.conditionObject[item.value]" type="android-cancel" class="icon-error"></Icon>
                    </div>
                </div>
            </template>
            <!-- 时间范围 -->
            <div class="row">
                <div class="row-left">时间范围</div>
                <div class="row-right">
                    <Input v-model="value.time"
                           @on-keyup="onTimeChange"
                           @on-change="onTimeChange"
                           placeholder="请输入时间"
                           style="width:2.25rem" />
                    <Select v-model="value.timeType" style="width:1.035rem">
                        <Option v-for="(value,key) in timeList" :value="key" :key="key">{{value}}</Option>
                    </Select>
                    <Icon v-if="reg.time" type="android-cancel" class="icon-error"></Icon>
                </div>
            </div>
            <!-- 执行 -->
            <div class="row">
                <div class="row-left">执行</div>
                <div class="row-right">
                    <p>{{actionList[value.type]}}</p>
                </div>
            </div>
            <!-- 状态 -->
            <div v-if="showStatus" class="row">
                <div class="row-left">状态</div>
                <div class="row-right">
                    <i-switch size="large" v-model="value.status" :true-value="1" :false-value="2">
                        <span slot="open">ON</span>
                        <span slot="close">OFF</span>
                    </i-switch>
                </div>
            </div>
            <!-- 状态 -->
            <div v-if="showStatus" class="row">
                <div class="row-left">应用于</div>
                <div class="row-right">
                    <cExDropdown 
                        v-if="show"
                        v-model="value.campaignIds"
                        :sourceList="campaignList"
                        code="id" 
                        left="id" 
                        leftName="广告组ID"
                        right="name"
                        rightName="广告组名称"
                        @changeCount="(val)=>(campaignCount=val)"
                    >
                        <Input :readonly="true" :value="`已选${campaignCount}项`" style="width:3.33rem" icon="arrow-down-b"/>
                    </cExDropdown>
                </div>
            </div>
        </div>
        <!-- 底部按钮 -->
        <div slot="footer">
            <Button type="text" @click="$emit('update:show',false)">取消</Button>
            <Button type="primary" size="large" @click="onSave">保存</Button>
        </div>
    </Modal>
</template>
<script>
import { mapState } from 'vuex';
import reg from '@/mixins/reg';
import cExDropdown from '@/components/commons/cExDropdown.vue';
export default {
    name: 'optimizationModal',
    mixins: [reg],
    components: { cExDropdown },
    props: {
        // 表单对象
        value: {
            type: Object,
            default: () => {},
        },
        // 控制模态框显示
        show: {
            type: Boolean,
            default: () => true,
        },
        //类型 add or edit
        type: {
            type: String,
            default: 'add',
        },
        //是否显示状态按钮
        showStatus: {
            type: Boolean,
            default: true,
        },
        //广告组列表
        campaignList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showModal: this.show,
            //验证
            reg: {},
            //广告组
            campaignCount: 0,
        };
    },
    computed: {
        ...mapState({
            dimensionValue: state => state.autoOptimization.dimensionValue,
            dimensionList: state => state.autoOptimization.dimensionList,
            timeList: state => state.autoOptimization.timeList,
            quotaList: state => state.autoOptimization.quotaList,
            mathList: state => state.autoOptimization.mathList,
            unitList: state => state.autoOptimization.unitList,
            actionList: state => state.autoOptimization.actionList,
        }),
    },
    watch: {
        show: function(newVal, oldVal) {
            if (this.showModal != newVal) this.showModal = newVal;
            this.reg = this.getReg();
        },
    },
    created() {
        this.reg = this.getReg();
    },
    methods: {
        /**
         * @desc: 生成一个reg对象
         * @return {Object}
         */
        getReg() {
            const obj = {
                conditionArr: false,
                time: false,
                conditionObject: {},
            };
            for (let i = 1; i <= 9; i++) obj.conditionObject[i] = false;
            return obj;
        },
        /**
         * @desc:时间变化时只能输入数字
         * @param {Event} event 事件对象
         */
        onTimeChange(event) {
            this.value.time = this.regNum(event, 0, 0, 99);
        },
        /**
         * @desc:指标数值变化时只能输入数字
         * @param {Event} event事件对象
         */
        onIndicatorValueChange(event) {
            let num = 2;
            if (event.target.id == 3) num = 0;
            if (event.target.id == 4) num = -1;
            this.value.conditionObject[event.target.id].indicatorValue = this.regNum(event, num);
        },
        /**
         * @desc: 模态框状态变化
         * @param {Boolean} bool 变化时的状态
         */
        onVisibleChange(bool) {
            if (this.show != bool) this.$emit('update:show', bool);
        },
        /**
         * @desc: 点击保存
         */
        onSave() {
            let regFlag = false;
            let value = this.value;
            //没有选择条件
            if (!value.conditionArr.length) {
                this.reg.conditionArr = true;
                regFlag = true;
            } else this.reg.conditionArr = false;
            //没有填写ctr数值
            for (let i = 1; i < 10; i++) {
                if (value.conditionArr.includes(i) && value.conditionObject[i].indicatorValue == '') {
                    this.reg.conditionObject[i] = true;
                    regFlag = true;
                } else this.reg.conditionObject[i] = false;
            }
            //没有填写时间数值
            if (value.time == '') {
                this.reg.time = true;
                regFlag = true;
            } else this.reg.time = false;

            //如果信息有误
            if (regFlag) {
                this.$Message.error({ content: '请填写正确的信息', duration: 1.5 });
                return;
            }
            if (this.type == 'edit') {
                this.$Modal.confirm({
                    content: `<p style="font-weight:bold;font-size:0.14rem;">保存后将对所有应用了该规则的广告组生效。</p>
				<p style="color:#999999;font-size:0.14rem;margin-top:0.2rem;">是否继续？</p>`,
                    okText: '继续',
                    onOk: () => {
                        if (!value.name) this.connectName(value);
                        this.$emit('update:show', false);
                        this.$emit('on-save');
                    },
                });
            } else {
                if (!value.name) this.connectName(value);
                this.$emit('update:show', false);
                this.$emit('on-save');
            }
        },
        /**
         * @desc: 拼接规则名称
         * @param {Object} value 表单对象
         */
        connectName(value) {
            value.name = `${value.time + this.timeList[value.timeType]}内${this.dimensionValue[value.type]}`;
            value.conditionArr.forEach((con, index) => {
                const condition = value.conditionObject[con];
                value.name += `${this.quotaList.filter(item => item.value == con)[0].label +
                    this.mathList[condition.operator - 1].label +
                    condition.indicatorValue +
                    this.unitList[con]}`;
                if (index != value.conditionArr.length - 1) value.name += '且';
            });
            value.name += this.actionList[value.type];
        },
    },
};
</script>
<style lang="scss">
.optimization-modal {
    .ivu-modal-wrap {
        top: -20%;
    }
    .title {
        font-size: 0.18rem;
        padding: 0.05rem 0.1rem 0 0.1rem;
        height: auto;
    }
    .optimization-modal {
        .row {
            display: flex;
            align-items: center;
            line-height: 0.46rem;
            height: 0.46rem;
            font-size: 0.15rem;
            .row-left {
                flex: 0 0 1rem;
                text-align: right;
                padding-right: 0.2rem;
            }
            .row-right {
                flex: 1 1 auto;
            }
        }
    }
    .ivu-select-dropdown {
        overflow: auto !important;
        max-height: 3.3rem !important;
        .dropdown-tool {
            display: flex;
            align-items: center;
            padding: 0 0.1rem 0.1rem 0.1rem;
            .dropdown-search {
                flex: 1 1 auto;
            }
            .blue-btn {
                flex: 0 0 auto;
                margin-left: 0.15rem;
                color: #237ec5;
                font-size: 0.14rem;
            }
        }
    }
    .ivu-dropdown {
        flex: 1 1 3.33rem;
        position: relative;
        width: 3.33rem;
    }
    .icon-error {
        font-size: 0.2rem;
        color: red;
        position: relative;
        top: 0.025rem;
        left: 0.05rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/optimizationModal.vue